/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { QuicklySignHealthCheckResponse } from './QuicklySignHealthCheckResponse';
import {
    QuicklySignHealthCheckResponseFromJSON,
    QuicklySignHealthCheckResponseFromJSONTyped,
    QuicklySignHealthCheckResponseToJSON,
} from './QuicklySignHealthCheckResponse';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfQuicklySignHealthCheckResponse
 */
export interface ResultOfQuicklySignHealthCheckResponse {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfQuicklySignHealthCheckResponse
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfQuicklySignHealthCheckResponse
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfQuicklySignHealthCheckResponse
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfQuicklySignHealthCheckResponse
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfQuicklySignHealthCheckResponse
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfQuicklySignHealthCheckResponse
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfQuicklySignHealthCheckResponse
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {QuicklySignHealthCheckResponse}
     * @memberof ResultOfQuicklySignHealthCheckResponse
     */
    data?: QuicklySignHealthCheckResponse;
    /**
     * 
     * @type {number}
     * @memberof ResultOfQuicklySignHealthCheckResponse
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfQuicklySignHealthCheckResponse interface.
 */
export function instanceOfResultOfQuicklySignHealthCheckResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfQuicklySignHealthCheckResponseFromJSON(json: any): ResultOfQuicklySignHealthCheckResponse {
    return ResultOfQuicklySignHealthCheckResponseFromJSONTyped(json, false);
}

export function ResultOfQuicklySignHealthCheckResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfQuicklySignHealthCheckResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : QuicklySignHealthCheckResponseFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfQuicklySignHealthCheckResponseToJSON(value?: ResultOfQuicklySignHealthCheckResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': QuicklySignHealthCheckResponseToJSON(value.data),
        'Count': value.count,
    };
}

